import React, { useContext, useMemo, useState } from 'react';

import { EditorContext, RicosContext, ToolbarContext, useTrackRender } from './../../../ricos-context';
import { RicosPortal } from './../../../editor-common';

import { MaxWidthCalculationWrapper } from '../../components/MaxWidthCalculationWrapper/MaxWidthCalculationWrapper';
import { Toolbar } from '../../components/Toolbar/Toolbar';
import { STATIC_TOOLBAR_DATA_HOOK } from './data-hooks';

export const StaticToolbar = () => {
  useTrackRender('Static toolbar');

  const { languageDir, theme, isMobile } = useContext(RicosContext);
  const { toolbarSettings } = useContext(ToolbarContext);
  const { toolbars } = useContext(ToolbarContext);
  const {
    adapter: { tiptapEditor },
  } = useContext(EditorContext);
  const [maxWidth, setMaxWidth] = useState(tiptapEditor.view.dom.clientWidth);

  if (toolbars.static.isEmpty()) {
    return null;
  }

  const disabledToolbarBySettings =
    typeof toolbarSettings.useStaticTextToolbar === 'object' &&
    toolbarSettings.useStaticTextToolbar.disabled;

  const toolbarItemsConfig = useMemo(
    () => toolbars.static.getToolbarItemsConfig({ disabled: disabledToolbarBySettings }),
    [toolbars.static, disabledToolbarBySettings]
  );

  const toolbarItemsRenderers = toolbars.static.getToolbarItemsRenderers();
  const htmlContainer = toolbarSettings.textToolbarContainer;

  if (htmlContainer) {
    return (
      <RicosPortal
        languageDir={languageDir}
        className={theme?.parentClass}
        container={htmlContainer}
      >
        <MaxWidthCalculationWrapper
          data-hook={STATIC_TOOLBAR_DATA_HOOK}
          dir={languageDir}
          setMaxWidth={setMaxWidth}
        >
          <Toolbar
            type="static"
            isMobile={isMobile}
            toolbarItemsConfig={toolbarItemsConfig}
            toolbarItemsRenderers={toolbarItemsRenderers}
            maxWidth={maxWidth}
            alignment={toolbarSettings.staticToolbarAlignment ?? 'left'}
          />
        </MaxWidthCalculationWrapper>
      </RicosPortal>
    );
  }

  if (toolbarSettings.useStaticTextToolbar) {
    return (
      <MaxWidthCalculationWrapper
        data-hook={STATIC_TOOLBAR_DATA_HOOK}
        dir={languageDir}
        setMaxWidth={setMaxWidth}
      >
        <Toolbar
          type="static"
          isMobile={isMobile}
          toolbarItemsConfig={toolbarItemsConfig}
          toolbarItemsRenderers={toolbarItemsRenderers}
          maxWidth={maxWidth}
          alignment={toolbarSettings.staticToolbarAlignment ?? 'left'}
        />
      </MaxWidthCalculationWrapper>
    );
  }

  return null;
};
